<template>
  <v-flex
    layout
    row
    align-center
    :class="[
      gameType === 'mcqSurvey' ? 'surveyClass' : null,
      gameType === 'mcqSurvey' && possibleToDelete
        ? 'surveyClassWithDelete'
        : null,
      gameType === 'mcq' ? 'mcqClass' : null,
      gameType === 'mcqImage' ? 'imageClass' : null,
      langEdition !== locale && answerText[locale] && showHint
        ? 'showHintClass'
        : null,
    ]"
  >
    <v-text-field
      class="answerField"
      v-if="gameType == 'mcq' || gameType == 'mcqSurvey'"
      v-model="answerText[langEdition]"
      outline
      :background-color="isCorrect ? 'green' : null"
      single-line
      @blur="updateAnswerText"
      :hint="langEdition !== locale ? answerText[locale] : null"
      :persistent-hint="showHint"
    >
      <language-translator
        v-if="locale !== langEdition"
        :langEdition="langEdition"
        :textToTranslate="answerText[locale]"
        :type="'answerText'"
        @text-translated="updateTranslatedText"
        slot="append"
      >
      </language-translator>
    </v-text-field>
    <image-input
      v-if="gameType == 'mcqImage'"
      :default="answerImage"
      :key="answerId"
      :showHint="showHint"
      :quizzImage="true"
      :langEdition="langEdition"
      @change-image-input="updateAnswerImage"
      @error="onImageError"
    ></image-input>

    <v-flex layout column>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-checkbox
            v-if="gameType !== 'mcqSurvey'"
            v-on="on"
            :class="[
              possibleToDelete ? 'checkBoxWithDelete' : 'onlyCheckBox',
              readOnly ? 'readOnlyClass' : null,
            ]"
            v-model="isCorrect"
            @change="updateAnswerCorrect"
            color="primary"
          >
          </v-checkbox>
        </template>
        <span> {{ $t('gameMcq.checkBox') }} </span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon
            v-if="possibleToDelete"
            v-on="on"
            color="red"
            class="deleteIcon"
            :class="'pointerClass'"
            @click="deleteAnswer()"
          >
            mdi-close
          </v-icon>
        </template>
        <span> {{ $t('gameMcq.delete') }} </span>
      </v-tooltip>
    </v-flex>
  </v-flex>
</template>

<script>
import ImageInput from './ImageInput';
import LanguageTranslator from '../components/LanguageTranslator.vue';

export default {
  name: 'GameMcq',
  components: {
    ImageInput,
    LanguageTranslator,
  },
  props: {
    answerId: {
      type: Number,
      default: null,
    },
    gameType: {
      type: String,
      default: null,
    },
    answer: {
      type: Object,
      default: null,
    },
    possibleToDelete: {
      type: Boolean,
      default: false,
    },
    langEdition: {
      type: String,
      default: null,
    },
    showHint: {
      type: Boolean,
      default: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCorrect: false,
      answerImage: { url: '', author: '', legend: { fr: '', en: '' } },
      answerText: '',
    };
  },
  created() {
    if (this.gameType === 'mcqImage') {
      if (this.answer) {
        this.answerImage = this.answer.picture;
      }
    } else {
      this.answerText = { fr: '', en: '' };
      this.answerText.en = this.answer.text.en;
      this.answerText.fr = this.answer.text.fr;
    }
    if (this.answer) {
      this.isCorrect = this.answer.isCorrect;
    }
  },
  watch: {
    answer(newValue) {
      if (this.gameType === 'mcqImage') {
        if (newValue && newValue.picture) {
          this.answerImage = newValue.picture;
        }
      } else {
        this.answerText = newValue.text;
      }
      if (this.answer) {
        this.isCorrect = newValue.isCorrect;
      }
    },
    gameType(newValue) {
      return newValue;
    },
  },
  methods: {
    updateAnswerText() {
      if (
        this.answerText[this.langEdition] !== this.answer.text[this.langEdition]
      ) {
        this.$emit(
          'update-answer-text',
          this.answerText[this.langEdition],
          this.answerId
        );
      }
    },
    onImageError(error) {
      console.log('imageError', error.message);
    },
    updateAnswerImage(newImage) {
      this.answerImage = newImage;
      this.$emit('update-answer-image', this.answerImage, this.answerId);
    },
    updateAnswerCorrect() {
      this.$emit(
        'update-answer-value',
        this.isCorrect,
        this.answerId,
        this.gameType
      );
    },
    deleteAnswer() {
      this.$emit('delete-answer', this.answerId, this.gameType);
    },
    async updateTranslatedText(textTranslated, type) {
      if (textTranslated) {
        if (type === 'answerText') {
          this.answerText[this.langEdition] = textTranslated;
          this.updateAnswerText();
        }
      }
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style lang="sass" scoped>
div.v-input
 width: 300px

.deleteIcon
  max-width: 20px;
  margin-left: 7px;
  margin-right: 10px;

.onlyCheckBox
  max-width: 20px
  margin-left: 5px
  margin-right: 10px
  margin-top: 0px

.checkBoxWithDelete
  max-width: 20px
  max-height: 24px
  margin-left: 5px
  margin-right: 10px
  margin-top: 0px

.surveyClass
  margin-right: 30px
  max-height: 66px
  justify: left

.surveyClassWithDelete
  margin-left: 35px
  max-height: 66px

.closeSurvey
  position: absolute

.mcqClass
  margin-top: 0px
  max-height: 66px

.imageClass
  margin-top: 0px
  max-height: 150px

.readOnlyClass
  pointer-events: none;

.showHintClass
  margin-bottom: 20px;
</style>
